import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-06-28 16:06:21
 * @LastEditTime: 2021-06-28 16:16:20
 * @LastEditors: wangshengqiang
 * @Description: 条款模块
 */
import React from 'react';
import _ from 'lodash';
import { ModuleContext } from '../BaseModule';
import './index.less';

const ClauseModule = props => {
  const {
    Render: RD,
    id,
    moduleUid,
    children
  } = props;
  if (!children || children.length === 0) return null;

  if (moduleUid) {
    return /*#__PURE__*/React.createElement(ModuleContext.Provider, {
      value: _objectSpread(_objectSpread({}, props), {}, {
        buttonCode: id
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "clause-module",
      id: id
    }, /*#__PURE__*/React.createElement(RD, {
      components: children
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "clause-module",
    id: id
  }, /*#__PURE__*/React.createElement(RD, {
    components: children
  }));
};

export default ClauseModule;